import React, { useEffect } from 'react';
import { useRouter } from 'next/router';

import ALink from '~/components/features/custom-link';

import FooterSearchBox from '~/components/common/partials/footer-search-box';
import FooterAccountBox from '~/components/common/partials/footer-account-box';
import { useAuth, useProgram } from '~/hooks';
import { isStoreReadOnly } from '~/utils/programAccess';

export default function StickyFooter() {
  let tmp = 0;
  const { program } = useProgram();
  const { participant } = useAuth();
  const { pathname } = useRouter();

  // Item activo segun la pagina visitada (se pinta con el color del programa
  // via .sticky-link.active en custom.scss). "Premios" cubre tienda, detalle
  // de premio y busqueda.
  const isHome = pathname === '/';
  const isShop = pathname === '/shop' || pathname.startsWith('/award') || pathname === '/search';
  const isCart = pathname === '/pages/cart';

  useEffect(() => {
    window.addEventListener('scroll', stickyFooterHandler);

    return () => {
      window.removeEventListener('scroll', stickyFooterHandler);
    };
  }, []);

  const stickyFooterHandler = (e) => {
    let stickyFooter = document.querySelector('.sticky-footer.sticky-content');
    if (stickyFooter) {
      stickyFooter.classList.add('fixed');
    }
  };

  return (
    <div>
      <div className="sticky-footer sticky-content fix-bottom fixed flex items-center justify-around">
        <ALink href="/" className={`sticky-link ${isHome ? 'active' : ''}`}>
          <i className="d-icon-home"></i>
          <span>Inicio</span>
        </ALink>

        <ALink href="/shop" className={`sticky-link ${isShop ? 'active' : ''}`}>
          <i className="d-icon-shoppingbag"></i>
          <span>Premios</span>
        </ALink>

        {!isStoreReadOnly(program?.id) && (
          <ALink href="/pages/cart" className={`sticky-link ${isCart ? 'active' : ''}`}>
            <i className="d-icon-bag"></i>
            <span>Carrito</span>
          </ALink>
        )}
        {program?.id !== 26 && (program?.supportPhone?.length ?? 0) > 1 && (
          <a
            href={`https://api.whatsapp.com/send?phone=593${program.supportPhone}&text=Hola!%20Soy%20un%20participante%20del%20programa%20${program.name},%20mi%20usuario%20es%20${participant.fullName},%20y%20tengo%20una%20duda%20sobre...`}
            target="_blank"
            className="sticky-link flex flex-col items-center"
          >
            <i className="fab fa-whatsapp"></i>
            <span>Contacto</span>
          </a>
        )}

        <FooterAccountBox />
      </div>
    </div>
  );
}
